/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const deleteDocumentAttachment = async (documentAttachmentId: string) => {
    const { data } = await apiInputService.delete(`/documentattachment/${documentAttachmentId}`);

    return data;
}

export const useDeleteDocumentAttachment = (options?: any) => {
    return useMutation(deleteDocumentAttachment, {
        ...options,
    });
}